module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("PART I")])]), _c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_c('p', {
    staticClass: "pt"
  }, [_vm._v("THE PLACENTA OF THE CRISIS")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("RENCH PHILOSOPHER AND AUTHOR")]), _vm._v(" V"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("OLTAIRE WAS THE FIRST")]), _vm._v(" to write about a Global Crisis in the seventeenth century. His "), _c('i', [_vm._v("Essay on the customs and character of nations, and on the principal facts of history from Charlemagne to Louis XIII")]), _vm._v(", composed in the 1740s for his friend, the Marquise du Châtelet (who, although an eminent mathematician, found history boring), set the wars and rebellions a century earlier within a global framework. Thus, after describing the murder of an Ottoman sultan in 1648, Voltaire immediately noted:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("This unfortunate time for Ibrahim was unfortunate for all monarchs. The Holy Roman Empire was unsettled by the famous Thirty Years’ War. Civil war devastated France and forced the mother of Louis XIV to flee with her children from her capital. In London, Charles I was condemned to death by his own subjects. Philip IV, king of Spain, having lost almost all his possessions in Asia, also lost Portugal.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("Voltaire went on to consider the careers of Cromwell in England, Li Zicheng in China, Aurangzeb in India, and others who had seized power by force, concluding that the mid-seventeenth century had been ‘a period of usurpations almost from one end of the world to the other’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-1",
      "id": "nr-part1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Voltaire's "), _c('i', [_vm._v("Essay")]), _vm._v(" repeatedly stressed the global dimension of the crisis: ‘In the flood of revolutions which we have seen from one end of the universe to the other, a fatal sequence of events seems to have dragged people into them, just as winds move the sand and the waves. The developments in Japan offer another example …’. Eventually, fearing that the marquise might still find his 174 chapters and 800 pages of ‘examples’ boring, he delivered his analysis in a single sentence: ‘Three things exercise a constant influence over the minds of men: climate, government and religion.’ Taken together, Voltaire proclaimed, they offer ‘the only way to explain the enigma of this world’. Two decades later, Voltaire re-read his "), _c('i', [_vm._v("Essay")]), _vm._v(" and added a number of "), _c('i', [_vm._v("Remarks")]), _vm._v(", including a fourth ‘thing’ that, he now believed, could ‘reconcile what was irreconcilable and explain what is inexplicable’ in human history: changes in population size."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-2",
      "id": "nr-part1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Voltaire's global vision has attracted few imitators. Although many subsequent historians have provided accounts filled with facts on ‘government and religion’ in the seventeenth century, until very recently few noted population trends and "), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_vm._v("virtually none considered the influence of the climate. Nevertheless, recent work by demographers and climatologists suggests that around 1618, when the human population of the northern hemisphere was larger than ever before, the average global temperature started to fall, producing extreme climate events, disastrous harvest failures and frequent disease epidemics. Human demographic systems can seldom adapt swiftly enough to such adverse events, yet instead of seeking ways to mitigate the natural disasters and save lives, most governments around the globe exacerbated the situation by continuing their existing policies, above all their wars. These various natural and human factors constituted a ‘placenta’ capable of nourishing a global catastrophe. Even though they did not constitute the catastrophe itself, an examination of the placenta explains why the catastrophe lasted for two generations, why it killed up to one-third of the human population, and why it transformed the world inhabited by the survivors."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-3",
      "id": "nr-part1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100318a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011PART_I_THE_PLACENTA_OF_THE_CRISIS.vue
// module id = 84
// module chunks = 0